import { map } from "lodash";
import { MenuItemOptionGroup } from "./menu-item-option-group";
export class MenuItemOption {
    constructor(id, name, isAvailable, priceCents, sortOrder, isDefault, allowsDuplicates, nestedOptionGroups) {
        this.id = id;
        this.name = name;
        this.isAvailable = isAvailable;
        this.priceCents = priceCents;
        this.sortOrder = sortOrder;
        this.isDefault = isDefault;
        this.allowsDuplicates = allowsDuplicates;
        this.nestedOptionGroups = nestedOptionGroups;
    }
    toString() {
        return `${this.name}; available: ${this.isAvailable}; price: ${this.priceCents}; option group count: ${this.nestedOptionGroups.length}`;
    }
    static fromDynamic(data) {
        const optionGroups = map(data["nested_option_groups"] ?? [], MenuItemOptionGroup.fromDynamic);
        // sort based on sort_order
        optionGroups.sort((a, b) => a.sortOrder - b.sortOrder);
        return new MenuItemOption(data["id"], data["name"], data["is_available"], data["price_cents"], data["sort_order"], data["is_default"] ?? false, data["allows_duplicates"] ?? false, optionGroups);
    }
}
//# sourceMappingURL=menu-item-option.js.map